import React from "react";
import Branding from "./Pemixcelspage/Navbardesign/Navbar";
import Footer from "./Pemixcelspage/Navbardesign/Footerpermixcel";
import Navbarpermicesls from "./Pemixcelspage/Navbardesign/Navbar";
export default function NewHomepage() {
  return (
   <>
   <Navbarpermicesls/>
  {/* <Branding/> */}
  <Footer/>

</>  );
}   